import { z } from 'zod';
import { SimulationAmountCentsVO } from "../../../../common/validators/value-objects.js";
export { SIMULATION_AMOUNT_LIMITS } from "../../../../common/validators/value-objects.js";
export const SimulationModeSchema = z.enum(['product_cost', 'total_cost']);
// Base schema containing all simulation-related fields
export const BaseApplicationSimulationDTOSchema = z.object({
    // Input fields
    requestedAmount: SimulationAmountCentsVO,
    interestRate: z.number().min(0).max(1),
    firstPaymentDate: z.iso.date(),
    disbursementDate: z.iso.date(),
    numPayments: z.number().int().min(1).max(120),
    tacRate: z.number().min(0).max(1),
    // Output fields
    totalAmountOwed: z.number().int().positive(),
    iofAmount: z.number(),
    tacAmount: z.number(),
    monthlyPaymentAmount: z.number(),
    annualInterestRate: z.number(),
    monthlyInterestRate: z.number(),
    monthlyEffectiveInterestRate: z.number(),
});
// Input DTO - fields required to request a simulation
export const SimulateApplicationInputDTOSchema = BaseApplicationSimulationDTOSchema.pick({
    requestedAmount: true,
    firstPaymentDate: true,
    disbursementDate: true,
    numPayments: true,
});
// Output DTO - fields returned from a simulation
export const SimulateApplicationOutputDTOSchema = BaseApplicationSimulationDTOSchema.pick({
    requestedAmount: true,
    numPayments: true,
    totalAmountOwed: true,
    iofAmount: true,
    tacAmount: true,
    monthlyPaymentAmount: true,
    annualInterestRate: true,
    monthlyInterestRate: true,
    monthlyEffectiveInterestRate: true,
}).extend({
    // Celcoin-derived: in total-cost mode it can fall below the simulation minimum.
    requestedAmount: z.number().int().positive(),
});
// HTTP Request DTO
export const SimulateApplicationRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.uuidv7(),
        facilityId: z.string(),
    }),
    body: SimulateApplicationInputDTOSchema,
});
// --- Bulk simulation -------------------------------------------------------
// Internal endpoint that returns one fully-simulated result per installment
// count. The single-term `/simulate` route above is kept unchanged so external
// integrators are unaffected.
// Inclusive range of installment counts the bulk simulation covers. Each count
// is simulated independently against Celcoin so every option carries its own
// real total, IOF and monthly payment.
export const SIMULATION_INSTALLMENT_RANGE = Object.freeze({
    minInstallments: 6,
    maxInstallments: 24,
});
// Input DTO - the bulk simulation discovers every installment option, so unlike
// the single-term input it carries no `numPayments`.
export const BulkSimulateApplicationInputDTOSchema = BaseApplicationSimulationDTOSchema.pick({
    requestedAmount: true,
    firstPaymentDate: true,
    disbursementDate: true,
}).extend({
    // Optional, not defaulted: validateRequest never writes the Zod output back to req.body.
    mode: SimulationModeSchema.optional(),
});
// HTTP Request DTO
export const BulkSimulateApplicationRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.uuidv7(),
        facilityId: z.string(),
    }),
    body: BulkSimulateApplicationInputDTOSchema,
});
//# sourceMappingURL=simulate-application.dto.js.map